import { useState, useEffect, useMemo } from 'react';
import { ImpersonationHeaderProps } from '@im/ui-lib/HeaderX4C';
import { useLocalization } from '@im/react-localization';
import { useDecodedToken } from 'mf_core/auth';
import { useDisableImpersonationMode } from './useDisableImpersonationMode';

type AlertColor = 'success' | 'info' | 'warning' | 'error';

const DEFAULT_MESSAGE_KEY = 'Impersonation.HeaderInfoAlert';

export function useImpersonationHeaderProps() {
  const { translate } = useLocalization();
  const decodedToken = useDecodedToken();

  const { isError, isPending, mutate } = useDisableImpersonationMode();

  const [alertMessageKey, setAlertMessageKey] = useState(DEFAULT_MESSAGE_KEY);
  const [alertSeverity, setAlertSeverity] = useState('info' as AlertColor);

  const resellerId = decodedToken?.imoProfile?.resellerId || '';

  const alertMessage = useMemo(() => {
    return translate(
      alertMessageKey,
      { resellerId: `&nbsp<b>${resellerId}</b>` },
      true
    );
  }, [alertMessageKey, resellerId, translate]);
  const enableLogoutButton = false;
  const exitButtonDisabled = false;

  const exitButtonLoading = isPending;

  const exitButtonText = useMemo(() => {
    return translate('Common.Exit');
  }, [translate]);

  const onImpersonationButtonClick = () => {
    mutate();
  };

  useEffect(() => {
    if (isError) {
      setAlertMessageKey('Impersonation.HeaderErrorAlert');
      setAlertSeverity('error');
    }
    const clearAlert = setTimeout(() => {
      setAlertMessageKey(DEFAULT_MESSAGE_KEY);
      setAlertSeverity('info');
    }, 3000);
    return () => {
      clearTimeout(clearAlert);
    };
  }, [isError]);

  return {
    alertMessage,
    alertSeverity,
    enableLogoutButton,
    exitButtonDisabled,
    exitButtonLoading,
    exitButtonText,
    onImpersonationButtonClick,
  } as ImpersonationHeaderProps;
}
